<script lang="ts">
  import { formatDistance, parseISO } from 'date-fns';
  
  // Convert from export let to $props()
  const { 
    date,
    addSuffix = true
  } = $props<{
    date: string | Date;
    addSuffix?: boolean;
  }>();
  
  function getTimeAgo(dateValue: string | Date): string {
    if (!dateValue) return '';
    
    const dateObj = typeof dateValue === 'string' ? parseISO(dateValue) : dateValue;
    return formatDistance(dateObj, new Date(), { addSuffix });
  }
  
  // Replace reactive statement with $derived
  const timeAgo = $derived(getTimeAgo(date));
</script>

<span>{timeAgo}</span>